// src/config/index.ts
class Config {
  private static instance: Config;
  private _config: any = {
    apiUrl: process.env.REACT_APP_API_URL || '/api/v1',
  };
  
  private constructor() {}
  
  static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }
  
  async loadConfig() {
    try {
      // Skip config loading if we're not authenticated
      const token = localStorage.getItem('access_token');
      if (!token) {
        console.log('Skipping config load - no auth token');
        return;
      }
      
      // Dynamic import to avoid circular dependency
      const { default: api } = await import('../services/api');
      const response = await api.get('/endpoints/config');
      if (response.data.success) {
        this._config = {
          ...this._config,
          ...response.data.config
        };
      }
    } catch (error: any) {
      console.error('Failed to load config:', error);
      // Don't throw error, just log it
      if (error.response?.status === 401) {
        console.log('Config load failed - unauthorized');
      }
    }
  }
  
  get apiUrl() {
    return this._config.apiUrl;
  }
}

export const config = Config.getInstance();
export default config;